import { render, staticRenderFns } from "./FarmerChangeItem.vue?vue&type=template&id=2c07dd05"
import script from "./FarmerChangeItem.vue?vue&type=script&lang=js"
export * from "./FarmerChangeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports